/**
 * 날짜/시간 포맷 유틸리티
 *
 * toLocaleDateString / toLocaleString 을 직접 인라인으로 쓰면
 * locale 문자열('ko-KR')과 옵션 객체가 파일마다 흩어지므로 여기서 일괄 관리한다.
 */

/** "2024. 1. 15." 형태 — 목록/카드의 날짜 표시에 사용 */
export function formatDate(value: string | Date): string {
  return new Date(value).toLocaleDateString('ko-KR');
}

/** "2024. 1. 15. 오후 3:05:00" 형태 — 상세 페이지의 등록일·수정일에 사용 */
export function formatDateTime(value: string | Date): string {
  return new Date(value).toLocaleString('ko-KR');
}

/** "2024년 1월 15일 오후 03:05" 형태 — MemberDetail 가입일에 사용 */
export function formatDateTimeFull(value: string | Date): string {
  return new Date(value).toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
